import { useState } from "react";

const faqs = [
  {
    q: "吃瓜投稿最常用的入口有哪些？",
    a: "目前开放的投稿入口主要分为四类：微信/企微号投稿、邮箱投稿、网页在线表单与站内私信、以及社群/后台留言等辅助渠道。不同入口时效与受理范围不同，建议按稿件类型选择，短线索走微信、长文走邮箱。",
  },
  {
    q: "吃瓜投稿需要附上证据材料吗？",
    a: "需要。为了提升采纳率并避免误传，最好在文字描述之外附上时间戳清晰的截图、聊天记录、凭证等佐证，并注明可公开的程度。信息不完整或无法核实的投稿往往不会被采用。",
  },
  {
    q: "邮箱投稿和微信投稿有什么区别？",
    a: "邮箱投稿适合内容较长、含较多附件的稿件，便于系统整理与归档；微信投稿沟通及时、可快速补充细节，适合边聊边核实的线索。紧急或长文建议走邮箱，短线索走微信更快。",
  },
  {
    q: "投稿后多久能收到回复？",
    a: "多数编辑台会在 24 到 72 小时内审阅。若内容时效性强请标注「紧急」，并尽量一次性把材料给全，能显著缩短审稿排队时间。未被单独回复不代表稿件被忽略。",
  },
  {
    q: "吃瓜投稿需要注意哪些边界？",
    a: "投稿前请务必确认信息来源真实、可核实，不捏造、不夸大、不含未经当事人同意的隐私与恶意攻击内容。真实、有依据、尊重他人的投稿更容易被采纳，也更安全。",
  },
  {
    q: "同一份瓜料可以投多个渠道吗？",
    a: "原则上不建议一稿多投。先走一个最匹配的入口即可，若长时间无回音再考虑通过第二个入口补充说明，避免给编辑台造成重复劳动。",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-question-answer-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
            关于吃瓜投稿，你最关心的问题
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            投稿前先扫一遍，多数疑问在这里就有答案。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200/70 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  aria-expanded={open}
                >
                  <h3 className="text-base font-semibold text-foreground-950 md:text-lg">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}